"use client"

import AuthForm from "../organisms/AuthForm/auth-form"
import AuthPage from "../templates/Auth/auth-template"
import React from "react"
import useLocaleStore from "@/app/stores/useLocaleStore"

const SignupPage: React.FC = () => {
const locale = useLocaleStore((state) => state.locale)


  return (
    <AuthPage>
      <AuthForm
        mode="signup"
        heading={locale === "en" ? "Sign Up And Start Selling Or Buying" : "ይመዝገቡ እና መሸጥ ወይም መግዛት ይጀምሩ"}
        buttonText={locale === "en" ? "Sign up" : "ተመዝገብ"}
        secondaryLinkText={locale === "en" ? "Log In" : "መግቢያ"}
        secondaryLinkHref="/auth/login"
        secondaryLinkLabel={locale === "en" ? "Already have an account?" : "መለያ አለህ?"}
      />
    </AuthPage>
  )
}

export default SignupPage
